import { render, staticRenderFns } from "./WorkRequestAttachments.vue?vue&type=template&id=36bc035c&"
import script from "./WorkRequestAttachments.vue?vue&type=script&lang=js&"
export * from "./WorkRequestAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports